import { SVGProps } from 'react';

const Lock = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
      <g clipPath='url(#clip0_18470_209593)'>
        <path
          d='M8.98574 0.645648C10.6478 -0.112094 12.5963 -0.203901 14.3269 0.37571C16.8221 1.18415 18.7514 3.3779 19.3804 5.90736C19.7627 7.3009 19.5845 8.75609 19.6284 10.1811C20.1957 10.4538 20.5985 11.0348 20.5876 11.672C20.5889 15.2346 20.5876 18.7972 20.5889 22.3598C20.6245 23.1957 19.9107 24.0055 19.0584 23.9904C14.3475 24.0014 9.63523 23.9767 4.92298 24C4.08166 23.9849 3.3705 23.1984 3.41161 22.3612C3.41298 18.7958 3.41024 15.2305 3.41435 11.6651C3.38558 11.0156 3.82953 10.484 4.35296 10.1647C4.39955 8.79172 4.2502 7.39681 4.58727 6.04987C5.11208 3.69854 6.77555 1.61989 8.98574 0.645648ZM10.3341 3.22718C9.06659 3.72457 8.06631 4.80569 7.6018 6.08002C7.10714 7.3516 7.34145 8.73828 7.28527 10.066C10.4327 10.066 13.5802 10.0674 16.7262 10.0647C16.6837 8.83831 16.8687 7.57358 16.4946 6.38147C16.1014 5.08933 15.1861 3.93833 13.9542 3.35735C12.8389 2.80514 11.4864 2.76267 10.3341 3.22718ZM10.5629 14.5344C10.3299 15.2428 10.7355 16.0047 11.3727 16.3376C11.2151 17.1926 11.0493 18.0477 10.8808 18.9013C11.6152 19.0123 12.362 18.9274 13.1019 18.9534C12.932 18.097 12.7621 17.2392 12.5388 16.3952C12.8923 16.1677 13.2568 15.895 13.3924 15.4757C13.672 14.7632 13.3006 13.8767 12.5854 13.5944C11.803 13.2286 10.7931 13.7081 10.5629 14.5344Z'
          fill={props.fill || '#232F3E'}
        />
      </g>
      <defs>
        <clipPath id='clip0_18470_209593'>
          <rect width='24' height='24' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Lock;
